import React, { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useForm } from "react-hook-form";
import moment from "moment";
import {
  Row,
  Col,
  Input,
  FormFeedback,
  FormText,
  Button,
  FormGroup,
  Label,
} from "reactstrap";

import attorneyService from "../../services/attorneyService";
import userActions from "../../actions/userActions";

const UpdatePersonalInfo = () => {
  const dispatch = useDispatch();
  const { register, handleSubmit, errors } = useForm();

  const { firstName, lastName, dob, userName } = useSelector(
    (state) => state.authentication.user
  );

  const [formState, setFormState] = useState({
    firstName: firstName,
    lastName: lastName,
    dob: moment(dob).format("MM/DD/YYYY"),
    userName: userName,
    token: "token",
    tokenExp: moment().format(),
  });

  const onChange = (evt) => {
    const { target } = evt;
    if (target) setFormState({ ...formState, [target.name]: target.value });
    //console.log(watchAll);
  };

  const onSubmit = (data) => {
    const fs = { ...formState, dob: moment(formState.dob).format() };
    //dispatch(userActions.updateLogin(fs));
    attorneyService
      .updatePersonalInfo(fs)
      .then((payload) => dispatch(userActions.updateLogin(payload)));
  };

  //const watchAll = watch();
  return (
    <React.Fragment>
      <Row>
        <Col xs={12}>
          <h1>Update personal information</h1>
        </Col>
      </Row>
      <Row>
        <Col>
          <p>
            Update your personal information here. If you have an existing
            appointmen the assigned attorney will be notified of your change.
            The attorney is notifed so that they can verfy that there is no
            conflict of interst.
          </p>
        </Col>
      </Row>
      <Row>
        <Col xs={12}>
          <form onSubmit={handleSubmit(onSubmit)}>
            <FormGroup row>
              <Label sm={12}>First name</Label>
              <Col sm={12}>
                <React.Fragment>
                  <Input
                    type="text"
                    name="firstName"
                    value={formState.firstName}
                    style={{ width: "90%" }}
                    onChange={(evt) => onChange(evt)}
                    innerRef={register({ required: true, min: 2 })}
                    invalid={errors.firstName ? true : false}
                  />
                  <FormText>Must be at least 2 characters long</FormText>
                  {errors.firstName && (
                    <FormFeedback>
                      The first name field must be at least 2 characters long.
                    </FormFeedback>
                  )}
                </React.Fragment>
              </Col>
            </FormGroup>
            <FormGroup row>
              <Label sm={12}>Last name</Label>
              <Col sm={12}>
                <React.Fragment>
                  <Input
                    type="text"
                    name="lastName"
                    value={formState.lastName}
                    style={{ width: "90%" }}
                    onChange={(evt) => onChange(evt)}
                    innerRef={register({ required: true, min: 2 })}
                    invalid={errors.lastName ? true : false}
                  />
                  <FormText>Must be at least 2 characters long</FormText>
                  {errors.lastName && (
                    <FormFeedback>
                      The last name field must be at least 2 characters long.
                    </FormFeedback>
                  )}
                </React.Fragment>
              </Col>
            </FormGroup>
            <FormGroup row>
              <Label sm={12}>DOB</Label>
              <Col sm={12}>
                <React.Fragment>
                  <Input
                    type="text"
                    name="dob"
                    value={formState.dob}
                    style={{ width: "90%" }}
                    onChange={(evt) => onChange(evt)}
                    innerRef={register({
                      required: true,
                      pattern: /^(0[1-9]|1[012])[- /.](0[1-9]|[12][0-9]|3[01])[- /.](19|20)\d\d$/,
                    })}
                    invalid={errors.dob ? true : false}
                  />
                  <FormText>Please format as mm/dd/yyyy.</FormText>
                  {errors.dob && <FormFeedback>Date is not valid</FormFeedback>}
                </React.Fragment>
              </Col>
            </FormGroup>
            <FormGroup row>
              <Label sm={12}>Email</Label>
              <Col sm={12}>
                <React.Fragment>
                  <Input
                    type="text"
                    name="userName"
                    value={formState.userName}
                    style={{ width: "90%" }}
                    onChange={(evt) => onChange(evt)}
                    innerRef={register({
                      required: true,
                      pattern: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
                      //pattern: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
                    })}
                    invalid={errors.userName ? true : false}
                  />
                  <FormText>Enter your email example@example.gov.</FormText>
                  {errors.userName && <span>This field is required</span>}
                </React.Fragment>
              </Col>
            </FormGroup>
            <Button type="submit">Submit</Button>
          </form>
        </Col>
      </Row>
    </React.Fragment>
  );
};

export default UpdatePersonalInfo;
